import React from "react";

import {
  Title,
  Banner,
  InfoParagraph,
  MutedText,
  LinkButton,
} from "./index.style";

const BannerComponent = () => {
  return (
    <Banner>
      <Title className="title">
        Find the right Job<h1>Candidates today.</h1>
      </Title>
      <InfoParagraph className="info">
        Search millions of resumes and get precisely targeted results for any
        field in an instant
      </InfoParagraph>
      <LinkButton href="#plans" className="banner-button">
        Select a Subscription
      </LinkButton>
      <MutedText className="mutted">
        Search resumes without a subscription
      </MutedText>
    </Banner>
  );
};

export default BannerComponent;
